import {AbstractTextContentVO} from "./AbstractTextContentVO";
import {Localize} from "../../localization/utils/Localize";

/**
 *
 *
 * For some reason games are using NumberVO to display simple numbers as string without localization (decimal points etc ), otherwise LocalizeNumber is used.
 * To avoid usage of Latin numbers now that Globalize handles Arabic numbers ( Flash did not) and to avoid refactor large parts of games, we expose this method, which will localize numbers only if current locale is arabic
 *  Since in many places games create a TextVO when  value is undefined and a NumberVO when is not,  and ("duh!") these implementations of AbstractTextContexVO have different methods for their value,  they are not exchangeable
 *  therefore i added the accepted type of empty
 */

export class NumberVO extends AbstractTextContentVO {
    public static NAME: string = "NumberVO";

    private _numberValue: number | empty = "";

    constructor(numberValue: number | empty) {
        super();

        this._numberValue = numberValue;
    }

    public get numberValue(): number | empty {
        return this._numberValue;
    }

    public set numberValue(value: number | empty) {
        this._numberValue = value;
        this.propertyChangedSignal.dispatch();
    }

    public compose(): string {
        if (typeof this._numberValue == "number") {
            return Localize.numberForArabic(this._numberValue as number);
        }
        else {
            return this._numberValue as string;
        }
    }

    public toString(): string {
        return NumberVO.NAME + ", numberValue: " + this._numberValue;
    }
}


type empty = "";